module.exports = __webpack_public_path__ + "media/icon_transaction/dog_4-88773b2d.png";